module.exports = __webpack_public_path__ + "img/logo2.46684ac9.png";